import { MenuIdPeople } from '@jira/navigation-apps__constants/src/MenuIdPeople.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { resources as teamDashboardResources } from '@atlassian/eoc-team-dashboard/resources';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { LazyTeamDashboardSidebar } from '@jira/navigation-apps__sidebar-eoc-team-dashboard/src/async.tsx';
import { opsTeamLayout } from '@jira/platform__layouts-ops-team-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { eocAutomationsRoute } from '@jira/router-routes__eoc-automations-routes/src/eocAutomationsRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import OpsTeamAutomation, { LazyOpsTeamAutomation } from './ui/spa/ops-team-automation/index.tsx';

export const eocAutomationsRouteEntry: Route = createEntry(eocAutomationsRoute, () => ({
	group: 'eoc',
	// eslint-disable-next-line no-restricted-syntax
	component: OpsTeamAutomation,
	layout: opsTeamLayout,

	resources: [
		...getNavigationResources(),
		...teamDashboardResources(),
		getConsolidationStateResource(),
	],

	navigation: {
		menuId: MenuIdPeople,
	},

	forPaint: [LazyAtlassianNavigation, LazyOpsTeamAutomation, LazyTeamDashboardSidebar],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
